import React, {useState} from 'react';
import styled from "styled-components";
import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import Btn from "../Btn";
import Tx from "../Tx";
import DialogActions from '@mui/material/DialogActions';
import {ValidatorForm} from 'react-material-ui-form-validator';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Text from "../Text";
import Button from '@mui/material/Button';
import {api} from "../../maps/data.js";
import IconBtn from "../IconBtn";

const WrapperStyled = styled.div`

`;

const DeleteIconStyled = styled.div`
    position: absolute;
    right: 10px;
    cursor: pointer;
`;

const SensorsListWrapperStyled = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, 300px);
    grid-gap: 25px;
    margin-top: 20px;
`;

const SensorsItemStyled = styled.div`
    padding: 10px;
    position: relative;
    min-height: 100px;
    font-size: 31px;
    display: grid;
    justify-content: center;
    align-content: center;
`;

const CreateNewWrapperStyled = styled.div`

`;

const SensorManufacturerType = ({sensorModels, forceModelsUpdate}) => {
    const [openCreate, s_openCreate] = useState(false);
    const [name, s_name] = useState("");

    const save = () => {
        if (!name) return;

        api({
            type: "createSensorModel",
            data: {name}
        }).catch(e => {
            console.error(e);
        });
        s_openCreate(false);
        forceModelsUpdate();
        s_name("");
    };

    const deleteSensorModel = async (id) => {
        api({
            type: "deleteSensorModel",
            data: {id}
        }).catch(e => {
            console.error(e);
        });
        s_openCreate(false);
        forceModelsUpdate();
    };

    return (
        <WrapperStyled>
            <CreateNewWrapperStyled>
                <Btn onClick={() => s_openCreate(true)}><Tx>firmware.create_new_model</Tx></Btn>
            </CreateNewWrapperStyled>
            <SensorsListWrapperStyled>
                {sensorModels.map((mod, idx) => {
                    return (
                        <Paper elevation={3} key={mod.name + idx}>
                            <SensorsItemStyled>
                                {mod.name}

                                <DeleteIconStyled
                                    onClick={() => {
                                        deleteSensorModel(mod._id);
                                    }}
                                >
                                    <IconBtn customtheme="normal" size="small" style={{marginLeft: 5}}>delete</IconBtn>
                                </DeleteIconStyled>
                            </SensorsItemStyled>
                        </Paper>
                    );
                })}
            </SensorsListWrapperStyled>
            {openCreate && (
                <Dialog
                    open={!!openCreate}
                    onClose={() => {
                        s_openCreate(false);
                    }}
                    maxWidth="xs"
                    fullWidth={true}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <ValidatorForm
                        onSubmit={save}
                        onError={errors => console.log(errors)}>
                        <DialogTitle id="alert-dialog-title">
                            Add new sensor model
                        </DialogTitle>
                        <DialogContent style={{paddingTop: 5}}>
                            <Text
                                label="user.name"
                                value={name}
                                onChange={s_name}
                                validators={['required']}
                                errorMessages={['this field is required', 'name is not valid']}/>

                        </DialogContent>
                        <DialogActions>

                            <Button onClick={() => {
                                s_openCreate(false);
                            }}><Tx>g.cancel</Tx></Button>
                            <Button
                                disabled={!name}
                                autoFocus type="submit">
                                <Tx>g.save</Tx>
                            </Button>

                        </DialogActions>
                    </ValidatorForm>
                </Dialog>
            )}
        </WrapperStyled>
    );
};

export default SensorManufacturerType;